module.exports = __webpack_public_path__ + "img/485.66bf7c5c.jpg";